export default __webpack_public_path__ + "static/media/404-settings.6684e036.svg";